// features/workstations/close/rehearse.js
// Rehearse mode — Jarvis role-plays the prospect so you practice the method.

import { useState } from 'react';

const card = { background: 'var(--surface-2)', border: '1px solid var(--border-3)', borderRadius: 12, padding: 20, marginBottom: 16 };
const inputStyle = { width: '100%', background: 'var(--surface-3)', border: '1px solid var(--border-2)', borderRadius: 8, padding: '10px 12px', color: 'inherit', fontSize: 14, fontFamily: 'inherit' };

export default function Rehearse() {
  const [product, setProduct] = useState('');
  const [prospect, setProspect] = useState('');
  const [started, setStarted] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    const text = input.trim();
    if (!text || busy) return;
    const history = [...msgs, { role: 'you', content: text }];
    setMsgs(history); setInput(''); setBusy(true);
    try {
      const res = await fetch('/api/workstations/close', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'rehearse', product, prospect, history }),
      });
      const data = await res.json();
      setMsgs((m) => [...m, { role: 'prospect', content: data.reply || '…' }]);
    } catch {
      setMsgs((m) => [...m, { role: 'prospect', content: '(connection error)' }]);
    } finally { setBusy(false); }
  };

  if (!started) {
    return (
      <div style={card}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Rehearse — Jarvis plays the prospect</div>
        <div style={{ fontSize: 13, color: '#9a9aa6', marginBottom: 16 }}>Practice the 12-step method against a realistic, mildly skeptical buyer.</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <input style={inputStyle} value={product} onChange={(e) => setProduct(e.target.value)} placeholder="What you're selling" />
          <input style={inputStyle} value={prospect} onChange={(e) => setProspect(e.target.value)} placeholder="The prospect (e.g. small landlord)" />
        </div>
        <button onClick={() => setStarted(true)} disabled={product.trim().length < 2}
          style={{ marginTop: 14, padding: '10px 18px', borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 14, cursor: product.trim().length < 2 ? 'not-allowed' : 'pointer', background: product.trim().length < 2 ? 'var(--surface-4)' : '#c8a96e', color: product.trim().length < 2 ? '#666' : '#1a1a1a' }}>
          Start role-play
        </button>
      </div>
    );
  }

  return (
    <div style={card}>
      <div style={{ fontSize: 11, letterSpacing: 0.6, textTransform: 'uppercase', color: '#9a9aa6', marginBottom: 12 }}>
        Rehearsing: {product} → {prospect || 'prospect'}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14, minHeight: 120 }}>
        {msgs.length === 0 && <div style={{ fontSize: 13, color: '#6a6a76' }}>You open — try: “Before I pitch you, mind if I ask a couple questions?”</div>}
        {msgs.map((m, i) => (
          <div key={i} style={{ alignSelf: m.role === 'you' ? 'flex-end' : 'flex-start', maxWidth: '80%', padding: '10px 14px', borderRadius: 12, fontSize: 13, lineHeight: 1.5, background: m.role === 'you' ? 'rgba(200,169,110,.12)' : 'var(--surface-3)', border: `1px solid ${m.role === 'you' ? 'rgba(200,169,110,.4)' : 'var(--border-3)'}` }}>
            <div style={{ fontSize: 10, color: '#6a6a76', marginBottom: 3 }}>{m.role === 'you' ? 'You' : 'Prospect (Jarvis)'}</div>
            {m.content}
          </div>
        ))}
        {busy && <div style={{ alignSelf: 'flex-start', fontSize: 12, color: '#6a6a76' }}>Prospect is thinking…</div>}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input style={inputStyle} value={input} onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') send(); }} placeholder="Your line…" />
        <button onClick={send} disabled={busy || !input.trim()}
          style={{ padding: '10px 18px', borderRadius: 8, border: 'none', fontWeight: 600, cursor: busy ? 'not-allowed' : 'pointer', background: '#c8a96e', color: '#1a1a1a' }}>Send</button>
      </div>
    </div>
  );
}
